export default [

     {
          path: '/major',
          name: 'Major',
          component: () => import("@/views/Page/Major/Major.vue"),
          meta: {
               title: 'Major',
          },
     }
];